import { Course } from '@model/CoursesClass';
import { toggleCpdModal } from '../store/actions/coursesActions';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useCpdModal = (course: Course) => {
  const dispatch = useDispatch();

  const openCpdModal = useCallback((e: React.MouseEvent, onSuccess?: () => void) => {
    e?.stopPropagation();
    dispatch(toggleCpdModal(true, course.courseId, onSuccess));
  }, [course.courseId, dispatch]);

  return {
    openCpdModal
  };
};

export default useCpdModal;